import styled from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const ContentPadding = styled.div`
  position: relative;
  padding-bottom: ${SIZING.unit(9.5)};
  @media ${device.tablet} {
    padding-bottom: ${SIZING.unit(11.125)};
  }
  @media ${device.laptop} {
    padding-bottom: 0;
  }
`;

export const StyledWrapper = styled.div`
  .embla {
    position: relative;
    --slide-height: 19rem;
    --slide-spacing: 32px;
    --slide-size: 371px;
    @media ${device.laptop} {
      --slide-spacing: 44px;
      --slide-size: 783px;
    }
    @media ${device.laptopL} {
      --slide-spacing: 44px;
      --slide-size: 885px;
    }
  }
  .embla__viewport {
    overflow: hidden;
    position: relative;
  }
  .embla__container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y pinch-zoom;
    // margin-left: calc(var(--slide-spacing) * 1);
  }
  .embla__slide {
    flex: 0 0 var(--slide-size);
    height: 641px;
    @media ${device.laptop} {
      height: 367px;
    }
    min-width: 0;
    padding-right: var(--slide-spacing);
  }
`;

export const BonusCTA = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  :hover,
  :focus {
    .tag-label {
      background-color: ${COLORS.grey15};
    }
  }
`;
